import { render, staticRenderFns } from "./task-detail.vue?vue&type=template&id=8d1699c6&scoped=true&"
import script from "./task-detail.vue?vue&type=script&lang=js&"
export * from "./task-detail.vue?vue&type=script&lang=js&"
import style0 from "./task-detail.vue?vue&type=style&index=0&id=8d1699c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1699c6",
  null
  
)

export default component.exports